import { Component } from '@verndale/core';
import YouTubeIframeLoader from 'youtube-iframe';
import Vimeo from '@vimeo/player';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      videoContainer: this.el.querySelector('.media-image-card__video-player'),
      videoId: this.el.querySelector('.media-image-card__video-player')?.dataset.videoId,
      videoType: this.el.querySelector('.media-image-card__video-player')?.dataset.videoType,
      playBtn: this.el.querySelector('.media-image-card__video-play'),
      pauseBtn: this.el.querySelector('.media-image-card__video-pause'),
      videoWrapper: this.el.querySelector('.media-image-card__video-container'),
      imageContainer: this.el.querySelector('.media-image-card__image img')
    };
    this.player = null;
    this.initPlayer();
  }

  addListeners() {
    if (this.dom.playBtn.dataset.customOpen) return;
    
    this.dom.playBtn?.addEventListener('click', () => {
      if (this.dom.videoType === 'vimeo') {
        this.player.play();
        this.dom.videoWrapper.style.zIndex = 0;
        this.dom.playBtn.hidden = true;
        this.unHidePlayButton(this.dom.pauseBtn);
      } else if (
        this.dom.videoType === 'youtube'
      ) {
        // this.player.playVideo();
      }
    });

    this.dom.imageContainer?.addEventListener('click', () => {
      if (this.dom.videoType === 'vimeo') {
        this.player.play();
        this.dom.videoWrapper.style.zIndex = 0;
        this.dom.playBtn.hidden = true;
        this.unHidePlayButton(this.dom.pauseBtn);
      } else if (
        this.dom.videoType === 'youtube'
      ) {
        // this.player.playVideo();
      }
    });


    this.dom.pauseBtn?.addEventListener('click', () => {
      if (this.dom.videoType === 'vimeo') {
        this.player.pause();
      } else if (
        this.dom.videoType === 'youtube'
      ) {
        this.player.pauseVideo();
      }
      this.dom.videoWrapper.style.zIndex = -1;
      this.dom.pauseBtn.hidden = true;
      this.unHidePlayButton(this.dom.playBtn);
    });
  }

  unHidePlayButton(btn) {
    btn.hidden = false;
  }

  createVimeoPlayer() {
    this.player = new Vimeo(this.dom.videoContainer, {
      id: this.dom.videoId,
      controls: false,
    });
  }

  createYouTubePlayer() {
    YouTubeIframeLoader.load(YT => {
      this.player = new YT.Player(this.dom.videoContainer, {
        videoId: this.dom.videoId,
        playerVars: {
          controls: 0,
        }
      });
    });
  }

  initPlayer() {
    if (this.dom.videoType === 'vimeo') {
      this.createVimeoPlayer();
    } else if (
      this.dom.videoType === 'youtube'
    ) {
      this.createYouTubePlayer();
    }
  }
}

export default Module;
